import React from "react";
import style from "./index.module.scss";
import { TopicsItem } from "../../../../../service";

interface SubjectiveProps {
    index?: number;
    data: TopicsItem;
}

export default function PageSubjectiveDetail({ data, index }: SubjectiveProps) {
    return (
        <div className={style.root}>
            <div className={style.top}>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（主观题）</span>
                <div className={style.title}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: data.contentText
                        }}
                    />
                </div>
                <div className={style.content}>
                    <div dangerouslySetInnerHTML={{ __html: data.stuAns }} />
                </div>
            </div>
        </div>
    );
}
